<template>
    <div class="ui field">
        <label>Game</label>
        <div class="ui fluid selection dropdown">
            <input type="hidden" name="file_definition_id">
            <i class="dropdown icon"></i>
            <div class="default text" v-if="hasDefinitions">Game</div>
            <div class="default text" v-else>Loading...</div>
            
            <div class="menu" v-if="hasDefinitions">
                <div class="item" v-for="fileDefinition in fileDefinitions" :key="fileDefinition.id" v-bind:data-value="fileDefinition.id" v-bind:data-length="fileDefinition.max_length">
                    {{ fileDefinition.game.name }} - {{ fileDefinition.name }}
                </div>
            </div>
            <div class="menu" v-else>
                <div class="item">
                    Loading...
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'campaign',
    ],

    data() {
        return {
            fileDefinitions: [],
            hasDefinitions: false,

            $dropdown: null
        };
    },

    mounted() {
        this.prepareComponent();
    },

    updated() {
        this.$dropdown.dropdown('setting', {
            onChange: (value, text) => {
                let definition = this.fileDefinitions.find(function(definition) { return definition.id == value; });
                this.$emit('change', definition, text);
            }
        });
    },

    methods: {
        prepareComponent() {
            this.$dropdown = $(this.$el).find('.dropdown');

            this.reloadDefinitions();
        },
        
        reloadDefinitions() {
            axios.get('/file-definitions/?include=game')
                .then(response => {
                    let definitions = response.data.filter((definition) => definition.accepts_filenames);
                    this.fileDefinitions = definitions
                    this.hasDefinitions = definitions.length > 0;

                    if (this.hasDefinitions) {
                        let definition = this.fileDefinitions[0];
                        this.$emit('change', definition, definition.game.name + ' - ' + definition.name)
                    }
                })
        }
    }
}
</script>